<template>
  <div class="promotion_new">
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Payment Promotion</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /
      <b>Marketing</b>
      /
      <b>Payment Promotion</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

      <div class="form-group">
        <label>Title</label>
        <input
          v-model="payment_promotion.title"
          class="form-control"
          placeholder="Promotion Title ...."
        />
      </div>

      <div class="form-group">
        <label>Content</label>
        <ckeditor :editor="editor" v-model="payment_promotion.content" :config="editorConfig"></ckeditor>
      </div>

      <div class="form-group">
        <label>Status</label>
        <select class="form-control" v-model="payment_promotion.active">
          <option value="0">Inactive</option>
          <option value="1">Active</option>
        </select>
      </div>

      <div class="form-group">
        <small>
          <b>{{ payment_promotion.created_at | moment("Do MMMM YYYY, h:mm a") }}</b>
        </small>
      </div>

      <input type="submit" class="btn btn-primary" @click="update()" />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import moment from "moment";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "payment_promotion",
  components: {
    ckeditor: CKEditor.component
  },
  data() {
    return {
      payment_promotion: {},
      deactive: [],
      editor: ClassicEditor,
      editorConfig: {
        toolbar: {
          items: [
              'heading',
              '|',
              'bold',
              '|',
              'bulletedList',
              '|',
              'numberedList',
              '|',
              'undo',
              '|',
              'redo',
              '|'
            ]
        },
      },
      image_link: ""
    };
  },

  methods: {
    async loadPaymentPromotion() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token === null) {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;
      
      let result = await axios.get("/payment_promotions", {
          headers: {
            Authorization: "Bearer " + token
          }
      })
      this.payment_promotion = result.data.data;
      if(this.payment_promotion.active == true) {
        this.payment_promotion.active = 1;
      } else {
        this.payment_promotion.active = 0;
      }
    },

    async update() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token === null) {
        swal({
          icon: 'error',
          text: 'You are not authorised'
        })
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;
      
      let result = await axios.post("/payment_promotions",
      {
        title: this.payment_promotion.title,
        content: this.payment_promotion.content,
        active: this.payment_promotion.active
      },
      {
          headers: {
            Authorization: "Bearer " + token
          }
      });

      swal({
        icon: result.data.success ? 'success' : 'error',
        text: result.data.message
      });
    },
  },

  async created() {
    await this.loadPaymentPromotion();
  }
};
</script>
